import {Injectable} from '@angular/core';
import {WindowReferenceService} from './window-reference.service';
import {Item, Project} from '../../project/shared/project-model';
import {SessionStorage} from "ngx-webstorage";
import {RangeDiscount} from "../../admin/shared";
import {RightsService} from "../rights/rights.service";
import {User} from "../user/user";

@Injectable({
  providedIn: 'root'
})

export class AddRemoveQuantityToCartEventDatalayerService {
  private window;

  @SessionStorage() currentItemct: Item;
  @SessionStorage() currentProject: Project;
  @SessionStorage() isNetPriceDisplayed: boolean;
  @SessionStorage() netPriceByPartnerDiscount: RangeDiscount[];
  @SessionStorage() user: User;

  constructor(private windowRef: WindowReferenceService, private rightsService: RightsService) {
    this.window = windowRef.nativeWindow;
  }

  private DataLayerTrigger(addRemoveQuantityToCartEvent) {
    if (addRemoveQuantityToCartEvent) {
      this.window.dataLayer.push({ecommerce: null});
      this.window.dataLayer.push(addRemoveQuantityToCartEvent);
    }
  }

  AddRemoveQuantityToCartEvent(nodeDetails: any, currency: string, isAddQuantity: boolean) {
    let offerItems: {}[] = [];
    let eventPrice = this.getEventPrice(nodeDetails.data);
    let itemListName = (isAddQuantity) ? "Bom - Adding Item" : "Bom - Removing Item";

    offerItems.push({
      item_id: (nodeDetails.data.id) ? nodeDetails.data.id : nodeDetails.data.ref,
      item_name: nodeDetails.data.ref,
      item_brand: 'Schneider Electric',
      item_category: nodeDetails.parent.data.category,
      item_list_name: itemListName,
      item_list_location: `configurator|EcoStruxure PowerBuild Contractors|${this.currentProject?.id}|${this.currentItemct.id}`,
      price: eventPrice,
      quantity: 1
    });

    let eCommerce = {
      currency: currency,
      value: eventPrice,
      items: offerItems,
      item_list_name: itemListName,
      item_list_location: `configurator|EcoStruxure PowerBuild Medium Voltage`,
      value_availability: (eventPrice > 0) ? 'true' : 'false'
    }

    let event;
    event = {
      event: "view_item_list",
      configurator_id: 46676,
      configurator_name: 'EcoStruxure PowerBuild Contractors',
      project_id: this.currentProject.id,
      project_name: this.currentProject.name,
      configuration_id: (this.currentItemct) ? this.currentItemct.id : '',
      configuration_name: (this.currentItemct) ? this.currentItemct.name : '',
      cta_name: itemListName,
      add_to_cart_location: 'Bom',
      number_of_configurations: 1,
      ecommerce: eCommerce,
      user_id: this.user.id
    }
    this.DataLayerTrigger(event);
  }

  AddRemoveProjectQuantityToCartEvent(nodeDetails: any, item: any, currency: string, isAddQuantity: boolean) {
    let offerItems: {}[] = [];
    let itemListName = (isAddQuantity) ? "Project Bom - Adding Item" : "Project Bom - Removing Item";
    let configuration_id = (nodeDetails.data.configurationId) ? nodeDetails.data.configurationId : item.id;

    if ((nodeDetails)) {
      let eventPrice = this.getEventPrice(nodeDetails.data);
      offerItems.push({
        item_id: (nodeDetails.data.id) ? nodeDetails.data.id : nodeDetails.data.ref,
        item_name: nodeDetails.data.ref,
        item_brand: 'Schneider Electric',
        item_category: nodeDetails.parent.data.category,
        item_list_name: itemListName,
        item_list_location: `configurator|EcoStruxure PowerBuild Contractors|${this.currentProject?.id}|${configuration_id}`,
        price: eventPrice,
        quantity: 1
      });
      let eCommerce = {
        currency: currency,
        value: eventPrice,
        items: offerItems,
        item_list_name: itemListName,
        item_list_location: `configurator|EcoStruxure PowerBuild Medium Voltage`,
        value_availability: (eventPrice > 0) ? 'true' : 'false'
      }

      let event: any;
      event = {
        event: "view_item_list",
        configurator_id: 46676,
        configurator_name: 'EcoStruxure PowerBuild Contractors',
        project_id: this.currentProject.id,
        project_name: this.currentProject.name,
        configuration_id: (nodeDetails.data.configurationId) ? nodeDetails.data.configurationId : item.id,
        configuration_name: (nodeDetails.data.configuration) ? nodeDetails.data.configuration : item.name,
        cta_name: itemListName,
        add_to_cart_location: 'Project Bom',
        number_of_configurations: 1,
        ecommerce: eCommerce,
        user_id: this.user.id
      }
      this.DataLayerTrigger(event);
    }
  }

  AddExportQuantityToCartEvent(items: Item[], allReferences: any, currency: string, currentProject: Project, isProjectBom: boolean, isMailStatus: boolean, mySeStatus?: boolean, cpqNumber?: any) {
    items.forEach((itemsValue) => {
      let offerItems: {}[] = [];
      let totalBomPrice = 0;
      const unixTimestamp = Math.floor(Date.now() / 1000);
      let lastConfigurationCategory = '';
      let itemGaChunks = [];

      let bomType = this.getBomType(isProjectBom, mySeStatus, isMailStatus, cpqNumber);

      if (allReferences) {
        allReferences.forEach((offerValue) => {
          let itemId = (offerValue.refId) ? offerValue.refId : offerValue.id;
          if (offerValue.category !== "Cubicle options") {
            lastConfigurationCategory = offerValue.category;
          }
          if (offerValue.ref && itemsValue.name === offerValue.configuration) {
            let eventPrice = this.getEventPrice(offerValue);
            let count = this.parseAndRoundPrice(offerValue.count);
            totalBomPrice = totalBomPrice + (eventPrice * count);
            offerItems.push({
              item_id: (itemId) ? itemId : offerValue.ref,
              item_name: offerValue.ref,
              item_list_name: bomType,
              item_list_location: `configurator|EcoStruxure PowerBuild Contractors|${currentProject?.id}|${itemsValue.id}`,
              item_brand: 'Schneider Electric',
              item_category: offerValue.category,
              price: eventPrice,
              quantity: offerValue.count
            });
          } else if (offerValue.configuration === undefined && offerValue.ref) {
            let eventPrice = this.getEventPrice(offerValue);
            let count = this.parseAndRoundPrice(offerValue.count);
            totalBomPrice = totalBomPrice + (eventPrice * count);
            offerItems.push({
              item_id: (itemId) ? itemId : offerValue.ref,
              item_name: offerValue.ref,
              item_list_name: bomType,
              item_list_location: `configurator|EcoStruxure PowerBuild Contractors|${currentProject?.id}|${itemsValue.id}`,
              item_brand: 'Schneider Electric',
              item_category: offerValue.category,
              price: eventPrice,
              quantity: offerValue.count
            });
          }
        });
      }

      itemGaChunks = this.chunkArray(offerItems, 40);

      itemGaChunks.forEach((gaItemArray) => {
        if (gaItemArray && gaItemArray.length > 0) {
          const eventPrice = gaItemArray.reduce((sum, item) => {
            const price = Number(item.price);
            const qty = Number(item.quantity || 0);
            return sum + (price * qty);
          }, 0);

          let eCommerce = {
            currency: currency,
            value: this.parseAndRoundPrice(eventPrice),
            items: gaItemArray,
            cart_id: unixTimestamp,
            value_availability: (this.parseAndRoundPrice(eventPrice) > 0) ? 'true' : 'false',
            item_list_name: (cpqNumber) ? "Push to Cpq" : bomType,
            item_list_location: `configurator|EcoStruxure PowerBuild Contractors`,
            item_list_option: "xlsx"
          }

          if (cpqNumber) {
            let event = {
              event: "view_item_list",
              configurator_id: 46676,
              configurator_name: 'EcoStruxure PowerBuild Contractors',
              project_id: currentProject.id,
              project_name: currentProject.name,
              configuration_id: itemsValue.id,
              configuration_name: itemsValue.name,
              cta_name: bomType,
              number_of_configurations: gaItemArray.length,
              ecommerce: eCommerce,
              quote_id: cpqNumber,
              user_id: this.user.id
            }
            this.DataLayerTrigger(event);
          } else {
            let event = {
              event: "view_item_list",
              configurator_id: 46676,
              configurator_name: 'EcoStruxure PowerBuild Contractors',
              project_id: currentProject.id,
              project_name: currentProject.name,
              configuration_id: itemsValue.id,
              configuration_name: itemsValue.name,
              cta_name: bomType,
              number_of_configurations: gaItemArray.length,
              ecommerce: eCommerce,
              user_id: this.user.id
            }
            this.DataLayerTrigger(event);
          }
        }
      });
    });
  }

  AddExportQuantityToMyseCartEvent(items: Item[], allReferences: any, currency: string, currentProject: Project, isProjectBom: boolean, isMailStatus: boolean, mySeStatus?: boolean, cpqNumber?: any) {
    items.forEach((itemsValue) => {
      let offerItems: {}[] = [];
      let totalBomPrice = 0;
      const unixTimestamp = Math.floor(Date.now() / 1000);
      let lastConfigurationCategory = '';
      let itemGaChunks = [];

      let bomType = this.getBomType(isProjectBom, mySeStatus, isMailStatus, cpqNumber);

      if (allReferences) {
        allReferences.forEach((offerValue) => {
          let itemId = (offerValue.refId) ? offerValue.refId : offerValue.id;
          if (offerValue.category !== "Cubicle options") {
            lastConfigurationCategory = offerValue.category;
          }
          if (offerValue.ref && itemsValue.name === offerValue.configuration) {
            let eventPrice = this.getEventPrice(offerValue);
            let count = this.parseAndRoundPrice(offerValue.count);
            totalBomPrice = totalBomPrice + (eventPrice * count);
            offerItems.push({
              item_id: (itemId) ? itemId : offerValue.ref,
              item_name: offerValue.ref,
              item_list_name: bomType,
              add_to_cart_location: `configurator|EcoStruxure PowerBuild Contractors|${currentProject?.id}|${itemsValue.id}`,
              item_brand: 'Schneider Electric',
              item_category: offerValue.category,
              price: eventPrice,
              quantity: offerValue.count
            });
          } else if (offerValue.configuration === undefined && offerValue.ref) {
            let eventPrice = this.getEventPrice(offerValue);
            let count = this.parseAndRoundPrice(offerValue.count);
            totalBomPrice = totalBomPrice + (eventPrice * count);
            offerItems.push({
              item_id: (itemId) ? itemId : offerValue.ref,
              item_name: offerValue.ref,
              item_list_name: bomType,
              add_to_cart_location: `configurator|EcoStruxure PowerBuild Contractors|${currentProject?.id}|${itemsValue.id}`,
              item_brand: 'Schneider Electric',
              item_category: offerValue.category,
              price: eventPrice,
              quantity: offerValue.count
            });
          }
        });
      }

      itemGaChunks = this.chunkArray(offerItems, 40);

      itemGaChunks.forEach((gaItemArray) => {
        if (gaItemArray && gaItemArray.length > 0) {
          const eventPrice = gaItemArray.reduce((sum, item) => {
            const price = Number(item.price);
            const qty = Number(item.quantity || 0);
            return sum + (price * qty);
          }, 0);

          let eCommerce = {
            currency: currency,
            value: this.parseAndRoundPrice(eventPrice),
            items: gaItemArray,
            cart_id: unixTimestamp,
            value_availability: (this.parseAndRoundPrice(eventPrice) > 0) ? 'true' : 'false',
            item_list_name: (cpqNumber) ? "Push to Cpq" : bomType,
            add_to_cart_location: `configurator|EcoStruxure PowerBuild Contractors`,
          }

          if (cpqNumber) {
            let event = {
              event: "add_to_cart",
              configurator_id: 46676,
              configurator_name: 'EcoStruxure PowerBuild Contractors',
              project_id: currentProject.id,
              project_name: currentProject.name,
              configuration_id: itemsValue.id,
              configuration_name: itemsValue.name,
              cta_name: "add to cart",
              number_of_configurations: gaItemArray.length,
              ecommerce: eCommerce,
              quote_id: cpqNumber,
              user_id: this.user.id
            }
            this.DataLayerTrigger(event);
          } else {
            let event = {
              event: "add_to_cart",
              configurator_id: 46676,
              configurator_name: 'EcoStruxure PowerBuild Contractors',
              project_id: currentProject.id,
              project_name: currentProject.name,
              configuration_id: itemsValue.id,
              configuration_name: itemsValue.name,
              cta_name: "add to cart",
              number_of_configurations: gaItemArray.length,
              ecommerce: eCommerce,
              user_id: this.user.id
            }
            this.DataLayerTrigger(event);
          }
        }
      });
    });
  }

  private getEventPrice(nodeDetails: any) {
    let unitPrice = 0;
    if (nodeDetails.discountUnitPrice && nodeDetails.discountUnitPrice !== 0 && this.rightsService.canApplyDiscount()) {
      unitPrice = this.parseAndRoundPrice(nodeDetails.discountUnitPrice);
    } else if (nodeDetails.unitPrice && nodeDetails.unitPrice !== 0) {
      unitPrice = this.parseAndRoundPrice(nodeDetails.unitPrice);
    } else if (nodeDetails.netPrice && nodeDetails.netPrice !== 0) {
      unitPrice = this.parseAndRoundPrice(nodeDetails.netPrice);
    } else if (nodeDetails.price && nodeDetails.price !== 0) {
      unitPrice = this.parseAndRoundPrice(nodeDetails.price);
    } else if (nodeDetails.discountedNetPrice && nodeDetails.count !== 0 && this.rightsService.canApplyDiscount()) {
      unitPrice = this.parseAndRoundPrice(nodeDetails.discountedNetPrice) / this.parseAndRoundPrice(nodeDetails.count);
    } else if (nodeDetails.totalNetPrice && nodeDetails.count !== 0) {
      unitPrice = this.parseAndRoundPrice(nodeDetails.totalNetPrice) / this.parseAndRoundPrice(nodeDetails.count);
    } else if (nodeDetails.totalPrice && nodeDetails.count !== 0) {
      unitPrice = this.parseAndRoundPrice(nodeDetails.totalPrice) / this.parseAndRoundPrice(nodeDetails.count);
    }
    unitPrice = this.parseAndRoundPrice(unitPrice);
    return unitPrice;
  }

  private parseAndRoundPrice(price: string | number): number | null {
    if (price === null || price === undefined) return 0;
    const priceString = price.toString();
    const parsedPrice = parseFloat(priceString.replace(/\s+/g, ''));

    if (!isNaN(parsedPrice)) {
      return Math.round(parsedPrice * 100) / 100;
    }
    return 0;
  }

  private getBomType(isProjectBom: any, mySeStatus: any, isMailStatus: any, cpqNumber: any) {
    let bomType = '';
    if (isProjectBom) {
      bomType = "Project BOM";
    } else {
      bomType = "BOM";
    }
    if (mySeStatus) {
      bomType = bomType + " - Order by mySchneider";
    } else if (isMailStatus) {
      bomType = bomType + " - Order by mail";
    }
    if (bomType) {
      bomType = bomType + " - Downloaded";
    }
    if (cpqNumber) {
      bomType = "Push to Cpq";
    }
    return bomType;
  }

  private chunkArray<T>(arr: T[], size: number): T[][] {
    const chunks: T[][] = [];
    for (let i = 0; i <= arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  }
}
